import React, { FC } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Forbidden from 'Auth/Forbidden';
import { anyRolesMatch } from 'User/utils/roles';
import { selectUserRoles } from 'User/selectors';
import { userPermissions } from 'shared/utils/permissions';
import CustomerRequestsLanding from 'CustomerRequests/pages/CustomerRequestsLanding';
import CeaseRouter from 'CustomerRequests/Cease/CeaseRouter';

const RequireRoles: FC<{ roles: any[] }> = ({ roles }) => {
  const userRoles = useSelector(selectUserRoles);

  if (anyRolesMatch(roles as any, userRoles)) {
    return <Outlet />;
  }

  return <Forbidden />;
};

const CustomerRequestsRouter: FC = () => {
  return (
    <Routes>
      <Route element={<RequireRoles roles={userPermissions.raiseCease} />}>
        <Route index element={<CustomerRequestsLanding />} />
        <Route path="cease/*" element={<CeaseRouter />} />
      </Route>
    </Routes>
  );
};

export default CustomerRequestsRouter;
